import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import History from 'react-router/lib/browserHistory';
import { connect } from 'react-redux';
import { openTopnav, onLoggedIn } from '../Actions';
import Session from '../Session';
import { get } from 'Language';

class ProfileTopAction extends Component {

    openMenu = () => {
        const { dispatch, isOpen } = this.props;
        dispatch(openTopnav(isOpen ? false : true));
    }

    closeMenu = () => {
        const { dispatch } = this.props;
        dispatch(openTopnav(false))
    }

    logout = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        sessionStorage.clear();
        dispatch(onLoggedIn(false));
        History.push('/', null);
    }

    render() {
        const { isLogin, isOpen } = this.props;

        if(isLogin) {
            const { first } = Session.getItem('profile');
            return (
                <div className={`btn-group pull-right top-button btn-custom ${isOpen ? 'open' : ''}`}>
                    <button
                        onClick={ this.openMenu }
                        type="button"
                        className="btn btn-success dropdown-toggle"
                        data-toggle="dropdown" aria-expanded="false">
                        <i className="fa fa-user"></i> { first } <span className="caret"></span>
                    </button>
                    <ul className="dropdown-menu" alt="menu">
                        <li>
                            <Link to="/profile" onClick={this.closeMenu}>
                                <i className="fa fa-user"></i>&nbsp;
                                { get('PROFILE_LINK') }
                            </Link>
                        </li>
                        <li>
                            <Link to="/profile/change-password" onClick={this.closeMenu}>
                                <i className="fa fa-key"></i>&nbsp;
                                { get('CHANGE_PASSWORD_LINK') }
                            </Link>
                        </li>
                        <li className="divider"></li>
                        {/*<li>
                            <a href="/" target="_blank">
                                <i className="fa fa-wrench"></i>&nbsp;
                                Admin
                            </a>
                        </li>*/}
                        <li>
                            <Link to="/" onClick={this.logout}>
                                <i className="fa fa-unlock"></i>&nbsp;
                                Log Out
                            </Link>
                        </li>
                    </ul>
                </div>
            )
        }

        return (
            <div className="col-md-6 col-xs-12">
                <div className="btn-group pull-right top-button btn-custom">
                    <Link to="/sign-in" className="btn btn-primary">
                        <i className="fa fa-sign-in"></i> { get('SIGN_IN') || 'Sign In'}
                    </Link>
                    <Link to="/sign-up" className="btn btn-success">
                        <i className="fa fa-pencil-square-o"></i> { get('JOIN_NOW') || 'Join Now'}
                    </Link>
                </div>
            </div>
        );
    }
}

export default connect(state => {
    const { isOpen } = state.bootstrap;

    return {
        isOpen
    }
})(ProfileTopAction);



// WEBPACK FOOTER //
// ./src/partials/ProfileTopAction.js